/**
 * Questions added through the Question Manager screen.
 *
 * They live in this browser's local storage so they show up immediately without
 * editing project files. The manager can also download them as a JSON file that
 * you can drop into src/data/questions/ to make them permanent.
 */
import type { Question } from '../types';
import { validateQuestion } from '../data/questionBank';
import { readJson, STORAGE_KEYS, writeJson } from './storage';

export function loadCustomQuestions(): { questions: Question[]; issues: string[] } {
  const raw = readJson<unknown[]>(STORAGE_KEYS.customQuestions, []);
  const questions: Question[] = [];
  const issues: string[] = [];
  if (!Array.isArray(raw)) return { questions, issues };
  for (const item of raw) {
    const result = validateQuestion(item, 'local storage');
    if (result.ok) questions.push({ ...result.value, isCustom: true });
    else issues.push(`${result.issue.id ?? 'unknown id'}: ${result.issue.message}`);
  }
  return { questions, issues };
}

export function saveCustomQuestions(questions: Question[]): boolean {
  return writeJson(STORAGE_KEYS.customQuestions, questions);
}

export function makeQuestionId(): string {
  const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const rand = Math.random().toString(36).slice(2, 7);
  return `custom-${stamp}-${rand}`;
}
